export default {
  letter: {},
  history_letter: {},
  reject: {},
  letters: [],
  table_one: [],
  table_two: [],
  periods: [],
  organizations: [],
}
